import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "static/constants";
import { downloadFile } from "app/utils/file";

import { getFormattedDateTime } from "utils/date";
import { getArchivedReports } from "app/services/archivedReports/archivedReports";
import formatDate from "utils/formatDate";

export const archiveReportApi = createApi({
  reducerPath: "archiveReportApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query, mutation }) => ({
    getArchiveReportList: query({
      queryFn: ({ page, pageSize, search, sorting, isFetch }) => {
        return {
          data: getArchivedReports({
            page,
            pageSize,
            search,
            sorting,
            isFetch,
          }),
        };
      },
    }),
    downloadReportList: mutation({
      queryFn: (query) => {
        return getArchivedReports(query, true).then(async (response) => {
          const fileName = `archive-reports-${getFormattedDateTime()}.xlsx`;

          await downloadFile(response, fileName);

          return { data: response };
        });
      },
    }),
    downloadBulkReports: mutation({
      queryFn: async (query) => {
        const response = await getArchivedReports(query, false, true);
        const date = formatDate(new Date(), "YYYY-MM-DD");
        var fileName = `archived-reports-${date}`;
        var a = document.createElement("a");

        const file = new Blob([response.data], {
          type: "application/zip",
        });
        const fileURL = URL.createObjectURL(file);

        document.body.appendChild(a);
        a.style = "display:none";

        a.href = fileURL;
        a.download = fileName;
        a.click();

        a.remove();
        return { data: null };
      },
    }),
  }),
});

export const {
  useDownloadReportListMutation,
  useDownloadBulkReportsMutation,
  useGetArchiveReportListQuery,
} = archiveReportApi;
